import { useEffect, useState } from "react";
import { collection, orderBy, query } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { getDate } from "@poseidon/firebase/timestamp";

export const useVulnerabilityNotesLog = (sailorId) => {
  const [vulnerabilityNotesLog, setIdvNotesLog] = useState([]);
  const [value, loading, error] = useCollection(
    query(
      collection(db, "sailorRiskProfiles", sailorId, "vulnerabilityNotes"),
      orderBy("createdAt", "asc")
    )
  );
  useEffect(() => {
    if (value) {
      const docs = value.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        createdAt: getDate(doc.get("createdAt")),
      }));
      setIdvNotesLog(docs);
    }
  }, [value]);

  return { vulnerabilityNotesLog, loading, error };
};
